var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FilterDisplay"},[_c('Select',{attrs:{"options":_vm.options,"placeholder":_vm.placeholder},on:{"change":_vm.onInput},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }